/**
 * FilterString class
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

export default class FilterString extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        filter: PropTypes.object,
        setFilter: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        libraryParams: PropTypes.object,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        libraryParams: {},
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        const { filter = {} } = this.props;
        const { like = '' } = filter;
        this.state = { value: like.replace('%', '') };
    }

    handleChange = event => {
        this.setState({
            value: event.target.value,
        });
    };

    handleKeyPress = event => {
        if (event.key === 'Enter') {
            const { setFilter } = this.props;
            setFilter(event.target.value ? { like: `%${event.target.value}%` } : null);
        }
    };

    render() {
        const { placeholder, libraryParams } = this.props;
        const { value } = this.state;
        const { intl: { formatMessage } } = this.context;
        return (
            <TextField
                inputProps={{ placeholder: placeholder ? formatMessage({ id: placeholder }) : '' }}
                value={value}
                margin="normal"
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPress}
                {...libraryParams}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFilters/Filters/FilterString.jsx